import { config } from '@rematter/config';

import { MaterialsReconciliationFormState } from '~/modules/trade/_state/loadReconciliation.state';

// Debug component to visualize materials reconciliation form state
export type DebugPanelProps = {
  hidden?: boolean;
  formState: MaterialsReconciliationFormState;
};

export const DebugPanel = ({ hidden, formState }: DebugPanelProps) => {
  if (hidden || config.isDevelopment) return null;

  return (
    <div className="@DebugPanel mt-8 border-t border-neutral/20 pt-4">
      <h3 className="mb-4 text-base font-bold">Debug Panel</h3>
      <div className="grid grid-cols-3 gap-4">
        <div>
          <h4 className="mb-2 font-semibold">Received Line Items:</h4>
          <pre className="max-h-[400px] max-w-full overflow-auto rounded bg-neutral/10 p-4 text-sm break-words">
            {JSON.stringify(formState.receivedLineItems, null, 2)}
          </pre>
        </div>
        <div>
          <h4 className="mb-2 font-semibold">Deductions:</h4>
          <pre className="max-h-[400px] max-w-full overflow-auto rounded bg-neutral/10 p-4 text-sm break-words">
            {JSON.stringify(formState.deductions, null, 2)}
          </pre>
        </div>
        <div>
          <h4 className="mb-2 font-semibold">Freight Charges:</h4>
          <pre className="max-h-[400px] max-w-full overflow-auto rounded bg-neutral/10 p-4 text-sm break-words">
            {JSON.stringify(formState.deductions || [], null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};
